import { Component, ElementRef } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-title',
  templateUrl: './title.component.html'
})
export class CardTitleComponent {
  constructor(
    public elementRef: ElementRef
  ) { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-card-title]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-card-title card-title'
  }
})
export class CardHeadingTitleComponent {
  constructor() { }
}
